export const modulus = {
    modulus10Validation,
    modulus11Validation
};

function modulus10Validation(number, log) {
    if(log) console.log("Modulus 10 validation on: " + number);
    var deltas = [0, 1, 2, 3, 4, -4, -3, -2, -1, 0];
    var checkSum = 0;

    for (var i = number.length - 1; i > -1; i--) {
        var j = parseInt(number.charAt(i))
        if (j < 0 || j > 9) return false;

        checkSum += j;
        if ((i - number.length) % 2 == 0) 
        {
            checkSum += deltas[j];
        }
    }
    return checkSum % 10 == 0;
}

function modulus11Validation(number, log) {
    if(log) console.log("Modulus 11 validation on: " + number);    
    var weight = 2;
    var checksum = 0;

    for (var i = number.length - 2; i > -1; i--) {        
        var j = parseInt(number.charAt(i))
        if (j < 0 || j > 9) return false;

        checksum += j * weight;
        weight++;
        if (weight > 10) weight = 1;
    }

    var control = number.charAt(number.length-1);
    if (control < 0 || control > 9) return false;

    var result = checksum % 11;
    return (result == 0 && control == 0) || (11 - result == control);
}    